export const PRODUCT_CATEGORIES = [
  {
    id: "cardiology",
    name: "Cardiology",
    description:
      "Therapies for cardiovascular health — managing hypertension, lipid disorders and ischemic conditions.",
    products: [
      {
        name: "Lenocor-5",
        composition: "Bisoprolol Fumarate 5mg",
        dosage_form: "Tablet",
        indication: "Hypertension & Angina",
      },
      {
        name: "Ato-Lenax 20",
        composition: "Atorvastatin 20mg",
        dosage_form: "Tablet",
        indication: "Hyperlipidemia",
      },
      {
        name: "Lenamlo-5",
        composition: "Amlodipine 5mg",
        dosage_form: "Tablet",
        indication: "Hypertension",
      },
      {
        name: "Lenosart-H",
        composition: "Losartan 50mg + Hydrochlorothiazide 12.5mg",
        dosage_form: "Tablet",
        indication: "Essential Hypertension",
      },
    ],
  },
  {
    id: "diabetes",
    name: "Diabetes",
    description:
      "Anti-diabetic formulations for glycemic control across the disease spectrum.",
    products: [
      {
        name: "Lenamet 500 SR",
        composition: "Metformin HCl 500mg (Sustained Release)",
        dosage_form: "Tablet",
        indication: "Type 2 Diabetes Mellitus",
      },
      {
        name: "Glip-Len M",
        composition: "Glimepiride 2mg + Metformin 500mg",
        dosage_form: "Tablet",
        indication: "Type 2 Diabetes Mellitus",
      },
      {
        name: "Lenagliptin 50",
        composition: "Vildagliptin 50mg",
        dosage_form: "Tablet",
        indication: "Type 2 Diabetes Mellitus",
      },
    ],
  },
  {
    id: "pediatrics",
    name: "Pediatrics",
    description:
      "Gentle yet effective formulations specially designed for infants and children.",
    products: [
      {
        name: "Lenamox Drops",
        composition: "Amoxicillin 100mg/ml",
        dosage_form: "Oral Suspension",
        indication: "Bacterial Infections",
      },
      {
        name: "Pedi-Len",
        composition: "Paracetamol 125mg/5ml",
        dosage_form: "Syrup",
        indication: "Fever & Mild Pain",
      },
      {
        name: "Lenakid Cough",
        composition: "Levosalbutamol + Ambroxol + Guaifenesin",
        dosage_form: "Syrup",
        indication: "Productive Cough & Bronchospasm",
      },
    ],
  },
  {
    id: "antibiotics",
    name: "Antibiotics",
    description:
      "Broad and targeted-spectrum antibacterials for community and hospital settings.",
    products: [
      {
        name: "Len-Azithro 500",
        composition: "Azithromycin 500mg",
        dosage_form: "Tablet",
        indication: "Respiratory Tract Infections",
      },
      {
        name: "Cef-Len 200",
        composition: "Cefixime 200mg",
        dosage_form: "Tablet",
        indication: "Urinary Tract Infections",
      },
      {
        name: "Lenaclav 625",
        composition: "Amoxicillin 500mg + Clavulanic Acid 125mg",
        dosage_form: "Tablet",
        indication: "Mixed Bacterial Infections",
      },
    ],
  },
  {
    id: "dermatology",
    name: "Dermatology",
    description:
      "Topical and systemic care for skin conditions, from acne to fungal infections.",
    products: [
      {
        name: "Lenaderm Cream",
        composition: "Clobetasol 0.05% + Neomycin + Miconazole",
        dosage_form: "Cream",
        indication: "Inflammatory & Mixed Skin Infections",
      },
      {
        name: "Acno-Len Gel",
        composition: "Adapalene 0.1% + Clindamycin 1%",
        dosage_form: "Gel",
        indication: "Acne Vulgaris",
      },
    ],
  },
  {
    id: "nutraceuticals",
    name: "Nutraceuticals",
    description:
      "Evidence-backed supplements supporting daily wellness and recovery.",
    products: [
      {
        name: "Lenamin Gold",
        composition: "Multivitamin + Multimineral + Ginseng",
        dosage_form: "Soft Gelatin Capsule",
        indication: "General Wellness & Fatigue",
      },
      {
        name: "Lenacal-K2",
        composition: "Calcium Citrate 1000mg + Vitamin D3 + K2-7",
        dosage_form: "Tablet",
        indication: "Bone Health & Osteopenia",
      },
    ],
  },
];

export const OPEN_POSITIONS = [
  {
    title: "Medical Representative",
    location: "Multiple Cities — Maharashtra & Madhya Pradesh",
    type: "Full-time",
    department: "Sales & Marketing",
  },
  {
    title: "Area Sales Manager",
    location: "Maharashtra & Madhya Pradesh",
    type: "Full-time",
    department: "Sales & Marketing",
  },
  {
    title: "Regional Sales Manager",
    location: "Maharashtra & Madhya Pradesh",
    type: "Full-time",
    department: "Sales & Marketing",
  },
  {
    title: "Hospital Key Account Manager",
    location: "Multiple Cities",
    type: "Full-time",
    department: "Sales & Marketing",
  },
  {
    title: "Business Development Executive",
    location: "Corporate HQ",
    type: "Full-time",
    department: "Sales & Marketing",
  },
  {
    title: "Product / Brand Manager",
    location: "Corporate HQ",
    type: "Full-time",
    department: "Sales & Marketing",
  },
];
